import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiIconComponent } from '../../../ui/icon/icon.component';

/**
 * One "icon + label on the left, compact control on the right" row in Transaction details
 * (Budget, Date, Label). Project the control as content and an optional `[rowAction]` (for example
 * Split) that sits beside the label on desktop and drops under it on phones.
 */
@Component({
  selector: 'app-edit-transaction-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-transaction-row.component.html',
  host: { class: 'block w-full' },
  imports: [UiIconComponent],
})
export class EditTransactionRowComponent {
  readonly icon = input.required<string>();
  readonly label = input.required<string>();
}
